import { makeStyles, tokens } from "@fluentui/react-components";

export const stoplightColorMapper = {
  red: "rgb(253 201 181)",
  green: "rgb(208 251 184)",
  yellow: "rgb(251 251 184)",
  unavailable: "rgb(221 221 221)",
};

export const useLabelAccordionStyles = makeStyles({
  accordionItem: {
    borderLeftWidth: "4px",
    borderLeftStyle: "solid",
  },
  accordionHeader: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "wrap",
  },
  headerIcon: {
    marginRight: "8px",
  },
  accordionPanel: {
    marginLeft: "30px",
    marginBottom: "16px",
  },
  warningIcon: {
    color: tokens.colorPaletteRedForeground1,
  },
  checkIcon: {
    color: tokens.colorPaletteGreenForeground1,
  },
  counterBadge: {
    marginLeft: "8px",
  },
  summary: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    color: tokens.colorStrokeFocus1,
    paddingBlock: "8px",
    borderRadius: "4px",
  },
  summaryTitle: {
    fontWeight: "600",
    marginLeft: "12px",
  },
  labelAccordionControls: {
    display: "flex",
    gap: "8px",
    justifyContent: "space-between",
    marginBottom: "8px",
  },
  labelAccordionControlsButtons: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  labelAccordionViewButtons: {
    display: "flex",
    alignItems: "center",
    gap: "2px",
  },
  menuItem: {
    padding: "8px",
    borderRadius: "4px",
    marginBottom: "4px",
    cursor: "pointer",
    minWidth: "100%",
    "&:hover": {
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
  },
  menuItemSelected: {
    backgroundColor: tokens.colorNeutralBackground1Selected,
    "&:hover": {
      backgroundColor: tokens.colorNeutralBackground1Selected,
    },
    borderLeft: `4px solid ${tokens.colorNeutralBackground3Selected}`,
  },
  analysisTag: {
    color: tokens.colorStrokeFocus1,
    maxWidth: "30vw",
    minWidth: "20vw",
    height: "fit-content",
    "& span": {
      textOverflow: "ellipsis",
      whiteSpace: "wrap",
    },
  },
  dialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  promptContent: {
    whiteSpace: "pre-wrap",
    wordWrap: "break-word",
  },
  promptSection: {
    marginBottom: "1rem",
    "& h3": {
      marginBottom: "0.5rem",
    },
    "& pre": {
      fontFamily: "inherit",
      margin: 0,
      padding: "0.5rem",
      borderRadius: "4px",
      textWrap: "wrap",
    },
  },
  fullReportListItem: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  fullReportListItemTitle: {
    textDecoration: "underline",
  },
  warningBadge: {
    border: `1px solid ${tokens.colorStatusWarningBorder1}`,
    marginRight: "8px",
    "& span": {
      display: "flex",
      alignItems: "center",
      gap: "4px",
      "& svg": {
        width: "14px",
        height: "14px",
      },
    },
  },
});
